/* eslint-disable comma-dangle */
export const getCookie = (name) => {
  const matches = document.cookie.match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
    ),
  )
  return matches ? decodeURIComponent(matches[1]) : undefined
}

export const setCookie = (name, value) => {
  document.cookie = `${name}=${encodeURIComponent(value)};max-age=31540000`
}
